import { useMutation, gql } from '@apollo/client';

import { GET_PAGINATED_WORKING_CONDITIONS } from './get-paginated-working-conditions.hook';

export const CREATE_WORKING_CONDITION = gql`
  mutation createWorkingConditions($payload: CreateWorkingConditionInput!) {
    createWorkingCondition(payload: $payload) {
      _id
    }
  }
`;

export const useCreateWorkingCondition = ({ onSuccess }: { onSuccess: () => void }) => {
  const [createWorkingCondition] = useMutation(CREATE_WORKING_CONDITION, {
    refetchQueries: [GET_PAGINATED_WORKING_CONDITIONS],
    onCompleted: data => {
      if (data) {
        onSuccess();
      }
    },
  });

  return createWorkingCondition;
};
